import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';

export default function ConfirmationModal({
  isOpen,
  handleClose,
  submitChanges,
  title = 'Close Route',
  message = 'Are you sure you want to close this route?',
}) {
  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <DialogTitle>
        <Typography variant="h3" fontWeight="bold">
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={submitChanges}
          variant="contained"
          color="primary"
          autoFocus
        >
          Confirm
        </Button>
        <Button onClick={handleClose} variant="contained" color="error">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
